import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { convertDateToString, timeSince } from "../utils/function";
import { engApi } from "../api/engApi";
import { BsNewspaper } from "react-icons/bs";

const Home = () => {
  const [newsList, setNewsList] = useState([]);

  const styles = {
    img: {
      height: "auto",
      width: "100%",
      maxWidth: "500px",
    },
  };

  const getItem = async () => {
    const response = await engApi.get("/");

    setNewsList(response.data);
  };

  useEffect(() => {
    getItem();
  }, []);

  return (
    <div className="main">
      <main className="content">
        <div className="container-fluid p-0">
          <div className="container p-0">
            <h2 className="mb-5 fw-bold">ประกาศและข่าวประชาสัมพันธ์</h2>
            <div className="row">
              <div className="col-12 ">
                <div className="card">
                  <div className="card-body h-100">
                    {!!newsList.length &&
                      newsList.map((item) => {
                        return (
                          <div key={item?.id}>
                            <div className="d-flex align-items-start">
                              <div className="flex-grow-1 w-100">
                                <small className="float-end">
                                  {item && item.date
                                    ? timeSince(item?.date)
                                    : ""}
                                </small>
                                <div className="mb-2">
                                  <div className="h4 d-flex justify-content-start align-items-center ">
                                    <BsNewspaper />{" "}
                                    <span
                                      className="ms-2"
                                      style={{ color: "#0001a4" }}
                                    >
                                      {item?.title}
                                    </span>
                                  </div>
                                </div>
                                <img
                                  src={`https://eng.buu.ac.th/internship/assets/uploads/${item?.image_name}`}
                                  style={styles.img}
                                />

                                <p>{item?.content}</p>
                                <small className="text-muted">
                                  ประกาศโดย : {item?.sf_id}  วันที่
                                  {/* {item && item.date
                                    ? convertDateToString(item?.date)
                                    : ""} */}
                                  {" "} {item?.date}
                                </small>
                                <br />
                              </div>
                            </div>
                            <hr />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
